module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    },
    on: {
      "after-enter": _vm.afterEnter
    }
  }, [_c('div', {
    ref: "popup",
    staticClass: "popup",
    staticStyle: {
      "background-image": "url('static/img/main/point3/popup/bg.png')"
    }
  }, [_c('div', {
    staticClass: "popup-bg delay3"
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-inner "
  }, [_c('a', {
    staticClass: "close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "left delay6"
  }, [_c('div', {
    staticClass: "quotes quotes-right"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                    В пригороде Швебиш-Гмюнда есть сказочный сад. Тот самый, где вот уже почти 100 лет создают истинно натуральную косметику\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('span', {
    staticClass: "point"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                        Швeбиш-Гмюнд, Германия\n                    ")])]), _vm._v(" "), _c('h3', {
    staticClass: "head"
  }, [_vm._v("\n                        Сказочный сад "), _c('br'), _vm._v(" в Швeбиш-Гмюнд\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                        Weleda была одной из первых косметических марок, которая взялась выращивать ботаническое сырье в собственных садах. Сегодня их у компании восемь, и самый большой находится в городке Швебиш-Гмюнд, что в 50 километрах от Штутгарта. Как и другие, этот сад биодинамический: в нем не используются инсектициды и искусственные удобрения, хозяйство ведется в соответствии с ритмами природы (например, фазами Луны), а газонокосильщиками «работают» овцы и утки, свободно разгуливающие по саду. А неподалеку от сада специалисты Weleda применяют уникальные знания и технологии на практике, ведь именно здесь находится производство косметики.\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "right delay9"
  }, [_c('div', {
    staticClass: "popup-products"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('h4', {
    staticClass: "head"
  }, [_vm._v("\n                            Универсальный питательный крем SKINFOOD\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                        Крем с насыщенной текстурой и 100% натуральными ингредиентами.\n                            Один из первых продуктов Weleda, который до сих пор на пике популярности и востребован среди звезд и моделей в Англии и США.\n\n                    ")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BA%D1%80%D0%B0%D1%81%D0%BE%D1%82%D0%B0-%D0%BE%D1%82-%D0%BF%D1%80%D0%B8%D1%80%D0%BE%D0%B4%D1%8B/%D0%BD%D0%B0%D1%82%D1%83%D1%80%D0%B0%D0%BB%D1%8C%D0%BD%D0%B0%D1%8F-%D0%BA%D0%BE%D1%81%D0%BC%D0%B5%D1%82%D0%B8%D0%BA%D0%B0-weleda/%D1%84%D0%B8%D0%BB%D0%BE%D1%81%D0%BE%D1%84%D0%B8%D1%8F-%D1%83%D1%85%D0%BE%D0%B4%D0%B0/%D0%BA%D0%B0%D0%BA-%D0%BF%D0%B8%D1%82%D0%B0%D0%B5%D1%82%D1%81%D1%8F-%D0%B2%D0%B0%D1%88%D0%B0-%D0%BA%D0%BE%D0%B6%D0%B0?utm_source=afisha&utm_medium=card&utm_term=germany&utm_content=skin_food&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('places', 'click', 'know more ')
      }
    }
  }, [_vm._v("\n                            Подробнее\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "img img-popup3"
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/point3/popup/product.png",
      "alt": ""
    }
  })])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e46797c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/popups/popup3.vue
// module id = 550
// module chunks = 1